import { initReactI18next } from "react-i18next";
import i18n, { type ReadCallback, type ResourceKey } from "i18next";
import { ensureError } from "~/utils/error";

export const defaultNS = "global";
// Setting namespace array, as per: https://github.com/i18next/i18next/issues/1805#issuecomment-1191202578
export const ns = [defaultNS];

void i18n
  // passes i18n down to react-i18next
  .use(initReactI18next)
  // lazy-load resources
  .use({
    type: "backend",
    read: (language: string, namespace: string, callback: ReadCallback) => {
      import(`~/locales/${language}/${namespace}.json`)
        .then((data) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          const resource = (data?.default ?? data) as
            | ResourceKey
            | boolean
            | null
            | undefined;
          callback(null, resource);
        })
        .catch((err) => {
          callback(ensureError(err), null);
        });
    },
  })
  .init({
    ns,
    defaultNS,
    debug: process.env.NODE_ENV === "development",
    lng: "da", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    fallbackLng: "da",
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;

export type I18N = typeof i18n;
